angular.module('contactModule').component('listingContactSaveShare', {
	templateUrl: 'listingContactSaveShare/listingContactSaveShare.html',
	bindings: {
        hiddenObjWrapper: '<',
		extra: '<'
	}, 
	controller: ['$element', '$timeout', function($element, $timeout) {
		var ctrl = this;
        this.$onInit = () => {
		}; 

		this.$postLink = () => {
			$timeout(function () {
                let blimpForm = $element[0].querySelector('.w_blimp_form');
				if (blimpForm) {
                    new Blimp.Form(blimpForm, {
                        draggable: true,
                        show_veil: true,
                        replace_by_result: false
                    });
                }
            });
		};

        this.track = () => {
			_gaq.push(['_trackEvent', this.extra.sPageLabel, 'EmailListing', 'Email Start']);
        };
	}]
});